"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FABHelper = void 0;
class FABHelper {
    /** Grab FAB Attribute */
    static getAttribute(ID, attr) {
        return window.FAB_PLUGIN.to_display.find((e) => {
            return ID == e.ID;
        })[attr];
    }
}
exports.FABHelper = FABHelper;
